import { AuditorTask } from '../../models/AuditorTask';
import { TasksState } from './tasks.reducer';
import dayjs from 'dayjs';
import { produce } from 'immer';

export const MAXIMUM_OPEN_TASKS_FOR_SELF_ASSIGNMENT = 1;

export function groupTasks(tasks: AuditorTask[]): TasksState['availableTasks'] {
  const groups: TasksState['availableTasks'] = [];

  for (let i = 0; i < tasks.length; i++) {
    const task = tasks[i];
    const prevTask = tasks[i - 1];
    if (i === 0 || prevTask.branchId !== task.branchId || prevTask.periodId !== task.periodId) {
      groups.push({
        group: `${dayjs(task.periodId).format('MMM D')} - ${task.customerName} ${task.branchName}`,
        items: [task],
        periodId: task.periodId,
        branchId: task.branchId
      });
    } else {
      groups[groups.length - 1].items.push(task);
    }
  }

  // No cropping here - the server decides how much of the queue an auditor is shown.
  return groups;
}

export function addTaskToGroups(groups: TasksState['availableTasks'], task: AuditorTask): TasksState['availableTasks'] {
  return produce(groups, groups => {
    const group = groups.find(group => group.periodId === task.periodId && group.branchId === task.branchId);

    if (!group) {
      groups.unshift({
        branchId: task.branchId,
        periodId: task.periodId,
        group: `${dayjs(task.periodId).format('MMM D')} - ${task.customerName} ${task.branchName}`,
        items: [{ ...task, taken: false, assignedTo: null }]
      });
    } else {
      let existing = group.items.find(t => t.id === task.id);
      if (existing) {
        existing.taken = false;
        existing.assignedTo = null;
      } else group.items.push({ ...task, taken: false, assignedTo: null });
    }
  });
}
